import React from 'react'
import ReceiveReturnAcqisitionfilter from './features/ReceiveReturnAcqisition.filter'
import MolGrid, { Column } from '@moltech/molui/molgrid';
import Acquisitions from '../../Acquisitions';

const ReceiveReturnAcquisitions = () => {
  return (
    <div>
      <ReceiveReturnAcqisitionfilter />
      <div className=''>
        <MolGrid
          sortMode="single"
          showGridlines
          resizableColumns
          stripedRows
          scrollable
          scrollHeight="flex"
        >
          <Column field="sClientName1" header="PO#" sortable />
          <Column field="podate" header="PO Date" sortable />
          <Column field="scopetype" header="Scope Type Description"  sortable />
          <Column field="serialnumber" header="Serial Number"  />
          <Column field="cost" header="Cost"  />
          <Column field="date" header="Date Received"  />
        </MolGrid>
      </div>
    </div>
  )
}

export default Acquisitions(ReceiveReturnAcquisitions)
